import { gql } from '@apollo/client'

export const GET_SHOWS = gql`
  query GetShows(
    $from: String
    $to: String
    $loc: String
    $onlyClearStatus: Boolean
    $event_no: Int
    $show_no: Int
  ) {
    shows(
      from: $from
      to: $to
      loc: $loc
      onlyClearStatus: $onlyClearStatus
      event_no: $event_no
      show_no: $show_no
    ) {
      event_id
      show_id
      title
      subtitle
      start_time
      end_time
      doors_open
      execution_id
      category_id
      status_id
      room_id
      image_url
      updated_from {
        start_time
        end_time
        room_id
      }
      updated_to
      status
      event_status
      show_status
    }
  }
`

export const GET_SHOWS_BY_DATE = gql`
  query GetShowsByDate(
    $from: String
    $to: String
    $loc: String
    $onlyClearStatus: Boolean
  ) {
    showsByDate(
      from: $from
      to: $to
      loc: $loc
      onlyClearStatus: $onlyClearStatus
    ) {
      date
      shows {
        event_id
        show_id
        title
        subtitle
        start_time
        end_time
        doors_open
        execution_id
        category_id
        status_id
        room_id
        image_url
        updated_from {
          start_time
          end_time
          room_id
        }
        updated_to
        status
        event_status
        show_status
      }
    }
  }
`

export const GET_SHOWS_WITHOUT_GUEST_LISTS = gql`
  query {
    showsWithoutGuestLists {
      event_id
      show_id
      title
      subtitle
      start_time
      end_time
      doors_open
      execution_id
      category_id
      status_id
      room_id
      updated_from {
        start_time
        end_time
        room_id
      }
      updated_to
      status
      event_status
      show_status
    }
  }
`

export const GET_EXECUTION = gql`
  query GetExecution($event_id: String!, $show_id: String!) {
    execution(event_id: $event_id, show_id: $show_id) {
      execution_id
      show_data_id
    }
  }
`
